// The way on from a refused school link (invalid, not active, rate limited) or an Add student with
// no usable school: a signed-in parent can type a school code or go Home; a signed-out visitor
// returns to the entry. Always names what to do next, never just "Continue".
import { Link } from "expo-router";
import { StyleSheet, View } from "react-native";

import { makeStyles } from "@/theme/makeStyles";
import { Button } from "@/ui/Button";
import { Text } from "@/ui/Text";

import { JOIN_COPY } from "./copy";

const useStyles = makeStyles((t) =>
  StyleSheet.create({ stack: { gap: t.space.md } }),
);

export function WayOn({ signedIn }: { signedIn: boolean }) {
  const styles = useStyles();
  return (
    <View style={styles.stack}>
      <Text tone="muted">{JOIN_COPY.askSchool}</Text>
      {signedIn ? (
        <>
          <Link href="/enter-school-code?mode=add" asChild replace>
            <Button>{JOIN_COPY.codeStep.heading}</Button>
          </Link>
          <Link href="/" asChild replace>
            <Button variant="outline">{JOIN_COPY.goToHome}</Button>
          </Link>
        </>
      ) : (
        <Link href="/welcome" asChild replace>
          <Button>{JOIN_COPY.goToStart}</Button>
        </Link>
      )}
    </View>
  );
}
